import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Map } from 'immutable'

import { toggleHistoryButton } from './actions'

function mapStateToProps(state, hocProps) {
    return {
        historyButtons: state.getIn(['ui', 'blockTable', hocProps.tableId], Map()),
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ toggleHistoryButton }, dispatch)
}

export default function (InnerComponent) {
    return @connect(mapStateToProps, mapDispatchToProps)
    class extends Component {
        shouldComponentUpdate() {
            return true
        }

        render() {
            return <InnerComponent {...this.props} />
        }
    }
}
